import { JsonObject, JsonProperty } from 'json2typescript';
import { SearchResults } from '../searchResults';
import { Case } from './case';
import { CaseLite } from './caseLite';
import { Claim } from './claim';
import { ClaimType } from './claimType';


@JsonObject('CaseSearchResults')
export class CaseSearchResults extends SearchResults {
    @JsonProperty('results', [Case])
    results: Case[] = [];
}

@JsonObject('CaseSearchResultsLite')
export class CaseSearchResultsLite extends SearchResults {
    @JsonProperty('results', [CaseLite])
    results: CaseLite[] = [];
}

@JsonObject('ClaimTypeSearchResults')
export class ClaimTypeSearchResults extends SearchResults {
    @JsonProperty('results', [ClaimType])
    results: ClaimType[] = [];
}

@JsonObject('ClaimSearchResults')
export class ClaimSearchResults extends SearchResults {
    @JsonProperty('results', [Claim])
    results: Claim[] = [];
}

